import Diameter from '@/models/dackpartner/Diameter'
import { createDefaultDiameters } from '@/models/dackpartner/default/DefaultDiameters'
import { VehicleType, VEHICLE_TYPES, getAllVehicleTypes } from '@/models/dackpartner/VehicleType'

export default class DiameterConfig {
  public general: Array<Diameter> = []
  public suv: Array<Diameter> = []
  public van: Array<Diameter> = []

  public constructor(data: Record<string, unknown> = null) {
    if (!data) {
      data = {}
    }

    if (data.general) {
      const config = data.general as Array<Record<string, unknown>>
      this.general = config.map((item) => new Diameter(item))
    } else {
      this.general = createDefaultDiameters()
    }

    VEHICLE_TYPES.forEach((vehicleType) => {
      this.initializeVehicleType(vehicleType, data)
    })
  }

  private initializeVehicleType(vehicleType: VehicleType, data: Record<string, unknown>): void {
    if (data[vehicleType]) {
      const config = data[vehicleType] as Array<Record<string, unknown>>
      this[vehicleType] = config.map((item) => new Diameter(item))
    } else {
      this[vehicleType] = createDefaultDiameters()
    }
  }

  public getAllVehicleTypes(): VehicleType[] {
    return getAllVehicleTypes()
  }

  public clone(): DiameterConfig {
    const result = new DiameterConfig()
    Object.assign(result, this)
    return result
  }
}
